import { Position } from '@interfaces/models';

export const fixedIncomeAccountTypes = [
  // Whole share only
  `PREFERRED_STOCK`,
  `CONVERTIBLE_PREFERRED_STOCK`,
  `PREFERRED_STOCK_CONVERTIBLE`,
  `PREFERRED_STOCK_AMERICAN_DEPOSITORY_RECE`,
  // $1000 increments
  `CORPORATE_BOND`,
  `CONVERTIBLE_BOND`,
  `US_TREASURY_BILL`,
  `US_TREASURY_NOTE`,
  `US_TREASURY_BOND`,
  `OTHER_GOVERNMENT`,
  `US_TREASURY_ZERO_COUPON`,
  `CERTIFICATES_OF_DEPOSIT`,
  `COMMERCIAL_PAPER`,
  `SHORT_TERM_PAPER`,
  `SHORT_TERM_RESERVES`,
  `CERTIFICATE_OF_DEPOSIT`,
  `CORPORATE_BOND_NOTE`,
  `CORPORATE_BOND_NOTE_CONVERTIBLE`,
  `COMMERCIAL_PAPER_REGULAR_FLAT_DISCOUNT`,
  `COMMERCIAL_PAPER_REGULAR_INTEREST_BEARIN`,
  `CORPORATE_BOND_NON_CONVERTIBLE_DOMESTIC`,
  `CORPORATE_BOND_NOTE_CONVERTIBLE_DOMESTIC`,
  `CORPORATE_NOTE_NON_CONVERTIBLE_DOMESTIC`,
  `CORPORATE_UNITS_BONDS`,
  `FEDERAL_AGENCY_BOND`,
  `FEDERAL_AGENCY_PASS_THROUGH`,
  `FEDERAL_AGENCY_REGULAR_BILL`,
  `GOVERNMENT_BOND`,
  `TREASURY_BILL`,
  `TREASURY_BOND`,
  `TREASURY_INFLATION_INDEXED`,
  `TREASURY_NOTE`,
  `TREASURY_STRIPS`,
  `US_TREASURY_FUTURE_BILL`,
  `US_TREASURY_REGULAR_BOND_NOTE`,
  `BOND_UNIT`,
  `FIXED_INCOME_UNITS`,
  `BOND`,
  // $5000 increments
  `MUNI_ASSESSMENT_DIST`,
  `MUNICIPAL_BOND`,
  `MUNI_DOUBLE_BARRELED_BOND`,
  `MUNI_GENERAL_OBLIGATION`,
  `MUNI_REVENUE_BOND`,
  `MUNICIPAL_BOND_NOTE`,
  `MUNICIPAL_LEASES`,
  `MUNICIPAL_BOND_SERIAL`,
  `MUNICIPAL_NOTE_SHORT_TERM`,
  // $25000 (then $1000 after)
  `GOVERNMENT_MORTGAGE`,
  `COLLATERALIZED_MORTGAGE_OBLIGATION`,
  // Do not display
  `OTHER`,
  `MISCELLANEOUS_ASSETS`,
  `UNKNOWN`,
  `MISCELLANEOUS_FIXED_INCOME`,
  // Why null / undefined here as well? Is this correct?
  null,
  undefined,
];

/**
 * @deprecated - Please use isFixedIncome in @shared/helpers
 */
export function positionIsBond(
  position: Pick<Position, 'securityType'> | undefined | null,
): boolean {
  return fixedIncomeAccountTypes.includes(position?.securityType);
}
